
import { Routes, Route } from 'react-router-dom'
import { List, Item } from './components'

export const ModuleRoutes = () => (
  <>
    <List />
    <Routes>
      <Route path=":id" element={<Item />} />
    </Routes>
  </>
)
